module.exports = __webpack_public_path__ + "img/antes_despues_27.108e543a.png";